module.exports = __webpack_public_path__ + "img/logo.a4fdc51c.png";